import { render, staticRenderFns } from "./Rkjh.vue?vue&type=template&id=3816a5ae&scoped=true"
import script from "./Rkjh.vue?vue&type=script&lang=js"
export * from "./Rkjh.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3816a5ae",
  null
  
)

export default component.exports